
import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import AppHeader from '../parts/AppHeader';
import AppBreadcrumbs from '../parts/AppBreadcrumbs';

class MainFilterScreen extends Component {
    render(){

        return (
            <div>
                <AppHeader leftButton='Favorite' titleText='HBO-Rechten' titleTextLink='/' rightButton='Reset'/>
                <main>
                    <section className="title">
                        <h2>
                            Ik ben op zoek <br/> naar een werkvorm_
                        </h2>
                    </section>

                    <AppBreadcrumbs />

                    <section className="icons">
                        <div className={localStorage.getItem('didactisch-principe') ? 'active-icon': ''}>
                            <NavLink to="/didactisch-principe">
                                <span className="icons-han-red">
                                    <div className="didacticprin"></div>
                                </span>
                                <p className="checkifselected">
                                    Didactisch<br/>
                                    principe
                                </p>
                            </NavLink>
                        </div>
                        <div className={localStorage.getItem('breinwaarde') ? 'active-icon': ''}>
                            <NavLink to="/breinwaarde">
                                <span className="icons-han-red">
                                    <div className="breinwaardeicon"></div>
                                </span>
                                <p className="checkifselected">
                                    Breinwaarde
                                </p>
                            </NavLink>
                        </div>
                        <div className={localStorage.getItem('kennis-of-vaardigheidsvak') ? 'active-icon': ''}>
                            <NavLink to="/kennis-of-vaardigheidsvak">
                                <span className="icons-han-red">
                                    <div className="kennisicon"></div>
                                </span>
                                <p className="checkifselected">
                                    Kennis- of <br/>
                                    vaardigheidsvak
                                </p>
                            </NavLink>
                        </div>
                        <div className={localStorage.getItem('aantal-studenten') ? 'active-icon': ''}>
                            <NavLink to="/aantal-studenten">
                                <span className="icons-han-red">
                                    <div className="aantalicon"></div>
                                </span>
                                <p className="checkifselected">
                                    Aantal<br/>
                                    studenten
                                </p>
                            </NavLink>
                        </div>
                        <div className={localStorage.getItem('duur-voorbereiding') ? 'active-icon': ''}>
                            <NavLink to="/duur-voorbereiding">
                                <span className="icons-han-red">
                                    <div className="duuricon"></div>
                                </span>
                                <p className="checkifselected">
                                    Duur voorbereiding
                                </p>
                            </NavLink>
                        </div>
                        <div className={localStorage.getItem('duur-les') ? 'active-icon': ''}>
                            <NavLink to="/duur-les">
                                <span className="icons-han-red">
                                    <div className="lesicon"></div>
                                </span>
                                <p className="checkifselected">
                                    Duur les
                                </p>
                            </NavLink>
                        </div>
                    </section>
                </main>

                <footer>
                    <NavLink to="/resultaten">
                        Zoeken
                    </NavLink>
                </footer>
            </div>
        )
    }
}

export default MainFilterScreen;